import Select from './Select';
import Option from './Option';
import SelectPropTypes from './PropTypes';
import OptGroup from './OptGroup';

Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-select@8.6.2@rc-select/es/index.js
// module id = 231
// module chunks = 0 1